<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.5459 8H15.5459V12.5H8.0459V8H5.0459V35H35.0459V8H32.0459V12.5H24.5459V8ZM18.5459 14H8.0459V18.5H18.5459V14ZM21.5459 14H32.0459V18.5H21.5459V14ZM18.5459 20.75H8.0459V25.25H18.5459V20.75ZM21.5459 20.75H32.0459V25.25H21.5459V20.75ZM18.5459 27.5H8.0459V32H18.5459V27.5ZM21.5459 27.5H32.0459V32H21.5459V27.5Z"
      class="fill-current"
    />
    <path d="M9.4209 6.25H14.4209V11.25H9.4209V6.25Z" class="fill-current" />
    <path d="M25.6709 6.25H30.6709V11.25H25.6709V6.25Z" class="fill-current" />
  </svg>
</template>
